import { Routes } from '@angular/router';
import { changePasswordRoute } from './components/change-password/change-password.route';
import { forgotPasswordRoute } from './components/forgot-password/forgot-password.route';
import { forgotUsernameRoute } from './components/forgot-username/forgot-username.route';
import { editAccountInfoRoute } from './components/edit-account-info/edit-account-info.route';
import { changePinRoute } from './components/change-pin/change-pin.route';
import { homepageRoute } from 'app/layouts/homepage/components/homepage/homepage.route';
import { verifyOtpRoute } from 'app/layouts/homepage/components/verify-otp/verify-otp.route';
import {
    firstLoginRoute,
    firstLoginChangeInfoRoute,
    firstLoginVerifyOtpRoute
} from 'app/layouts/homepage/components/first-login/first-login.route';
import { errorRoute } from 'app/layouts';
import { notAllowedOrganizationRoute } from './components/not-allowed-organization/not-allowed-organization.route';

export const SELF_SERVICE_ROUTES = [
    changePasswordRoute,
    forgotUsernameRoute,
    forgotPasswordRoute,
    editAccountInfoRoute,
    changePinRoute,
    homepageRoute,
    verifyOtpRoute,
    firstLoginRoute,
    firstLoginChangeInfoRoute,
    firstLoginVerifyOtpRoute,
    notAllowedOrganizationRoute,
    ...errorRoute
];

export const selfServiceState: Routes = [
    {
        path: '',
        pathMatch: 'full',
        children: SELF_SERVICE_ROUTES
    }
];
